import Smartphones from 'Timesheet/views/TimesheetsView/containers/Smartphones'
import Tablets from 'Timesheet/views/TimesheetsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TimesheetsView = getCurrentDeviceView(Smartphones, Tablets)

export default TimesheetsView
